import { css, type Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { IAlertNotificationTypes } from '@shared/models/components/IAlertNotificationProps';
import TextButton from '../button/TextButton';
import { TextSize90 } from '../text/Typography';

export const CenterWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    gap: 0.5rem;
`;

export const AlertAccentWrapper = styled(CenterWrap)<{ $color?: IAlertNotificationTypes; $borderless?: boolean }>`
    border: 2px solid ${(props) => props.theme.banner[props.$color || 'default'].border};
    border-radius: 6px;
    background-color: ${(props) => props.theme.banner[props.$color || 'default'].background};
    color: ${(props) => props.theme.banner[props.$color || 'default'].text};
    ${(props) =>
        props.$borderless &&
        css`
            border: none;
            padding: 0;
            background-color: transparent;
        `}
`;

export const NotificationStatusWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
`;

export const NotificationWrap = styled.div`
    max-width: 1000px;
    width: 100%;
    margin: 1rem auto;
    padding: 2rem;
    border-radius: 6px;
    border: 2px solid ${(props) => props.theme.color.secondary};
    background-color: ${(props) => props.theme.color.secondary}25;
    &[data-isread='true'] {
        background-color: ${(props) => props.theme.color.accentCard};
        border: none;
        & * {
            color: ${(props) => props.theme.color.textBody};
        }
    }
    justify-self: center;
`;

export const NotificationListingWrap = styled.div`
    margin: 0 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
`;

export const ContentNotificationWrap = styled(NotificationListingWrap)`
    padding: 0;
    margin: 1rem 0;
    justify-content: center;
`;

export const NotificationAccentWrap = styled(NotificationWrap)<{ $color?: IAlertNotificationTypes }>`
    border: 2px solid ${(props) => props.theme.banner[props.$color ?? 'default'].border};
    background-color: ${(props) => props.theme.banner[props.$color ?? 'default'].background};
`;

const sharedStyles = (props: { theme: Theme; $color: IAlertNotificationTypes }) => css`
    .core-button {
        color: ${props.theme.banner[props.$color].buttonText ?? props.theme.banner[props.$color].text};
        border-color: transparent;
        background: ${props.theme.banner[props.$color || 'default'].border};

        :hover {
            color: ${props.theme.banner[props.$color].buttonText ?? props.theme.banner[props.$color || 'default'].text};
            border-color: transparent;
            background: ${props.theme.banner[props.$color || 'default'].border};
            text-decoration: underline;
        }
    }
    .text-button {
        color: ${props.theme.banner[props.$color || 'default'].linkText};
    }
`;

export const NotificationContent = styled.div<{ $color: IAlertNotificationTypes }>`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-content: center;
    ${(props) => props.$color !== 'default' && sharedStyles(props)};
`;

export const NotificationSubtitleAction = styled.div<{ $color: IAlertNotificationTypes }>`
    ${(props) => props.$color !== 'default' && sharedStyles(props)};
`;

export const SubtitleActionTextButton = styled(TextButton)`
    color: ${(props) => props.theme.banner.default.text};
    ${TextSize90}
    padding: 0 0.5rem;
    :hover {
        text-decoration: none !important;
    }
`;
